"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = void 0;
const core_1 = require("@apollo/client/core");
const vue_1 = require("vue");
// ? Vue Apollo 3 is not compliant with GraphQL 16
// ? https://github.com/vuejs/apollo/issues/1325#issuecomment-1593062018
// TODO Remove this patch when we migrate to Vue Apollo 4
// @ts-ignore
function gql(literals, ...args) {
    return (0, vue_1.markRaw)((0, core_1.gql)(literals, ...args));
}
exports.gql = gql;
//# sourceMappingURL=index.js.map